export enum RoundTypeIds {
  'ctm_standard' = 'ctm_standard',
  final = 'final',
}
